export default __webpack_public_path__ + "static/media/step-one.570a785f.svg";